import { Component, OnDestroy, OnInit } from '@angular/core';
import { EstadoCierre } from '@shared/enums/estadoCierre';
import { CierreDiarioService } from '../services/cierre-diario.service';
import { Step } from '@shared/models/cierreTurno/Step';
import { UsuarioService } from '@account/usuario.service';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';
import { Subscription } from 'rxjs';
import { EtapasCierre } from '@shared/enums/EtapasCierreTurno';

@Component({
  selector: 'app-cierre-turno-container',
  templateUrl: './cierre-turno-container.component.html',
  styleUrl: './cierre-turno-container.component.scss'
})
export class CierreTurnoContainerComponent implements OnInit, OnDestroy{
  
  cierre: CierreTurno;
  estadoActual: EstadoCierre;
  stepActual: Step;
  indexStep: number;
  EstadoCierre = EstadoCierre;
  EtapasCierre = EtapasCierre
  subscribe1$: Subscription;
  subscribe2$: Subscription;
  subscribe3$: Subscription;

  constructor(private cierreDiarioService: CierreDiarioService, private usuarioService: UsuarioService) {}

  ngOnInit() {
    this.cierreDiarioService.initStepProgress();
    
    this.subscribe1$ = this.cierreDiarioService.index$.subscribe(i => {
      this.indexStep = i;
    })

    this.subscribe2$ = this.cierreDiarioService.steps$.subscribe(s => {
      this.stepActual = s[this.indexStep]
    });

    this.subscribe3$ = this.cierreDiarioService.cierre$.subscribe(cierre => {
      this.cierre = cierre ?? null;
    });
  }

  ngOnDestroy() {
    this.cierreDiarioService.restart();
    this.subscribe1$.unsubscribe();
    this.subscribe2$.unsubscribe();
    this.subscribe3$.unsubscribe();
  }
}
